/**
 * 페이지 배경 — 표면의 역할로 이름을 붙인다(리터럴 색이 아니다).
 * - frame:   콘텐츠를 얹는 흰 표면 (sys.color.bg.frame)
 * - neutral: 한 단계 눌러앉은 회색 표면 (sys.color.bg.neutralLight)
 * - screen:  카드·패널이 떠 있는 앱 바탕 (sys.color.bg.screen)
 */
export const PAGE_BACKGROUNDS = ['frame', 'neutral', 'screen'] as const;
export type SPageBackground = (typeof PAGE_BACKGROUNDS)[number];
